import React from 'react';

export type TStatusIndicator = {
    className?: string;
    message?: string;
    placeholder?: string;
};

const StatusIndicator = ({className, message, placeholder = "Recommended Action"}: TStatusIndicator) => {
    return (
        <div className={`tw-rounded tw-bg-[#F4F5F7] tw-w-auto tw-flex tw-items-center tw-justify-start tw-pr-3 tw-box-border tw-gap-1.5 tw-text-center tw-text-xs tw-text-[#6D788C] ${className}`}>
            {placeholder === "Recommended Action" ? <div className="tw-h-8 tw-w-[5px] tw-relative tw-rounded-tl tw-rounded-tr-none tw-rounded-br-none tw-rounded-bl tw-bg-[#36B37E] tw-shrink-0" /> : <div className='tw-h-8 tw-w-[5px]'/>}
            <div className="tw-flex tw-items-start tw-justify-start tw-ps-1.5">
                <label className="tw-uppercase">{placeholder}</label>
            </div>
            <div className="tw-flex tw-items-start tw-justify-start tw-text-[#172B4D]">
                <label className="tw-font-medium">{message ?? 'Run either Control or Variation 1 in 100% traffic'}</label>
            </div>
        </div>
    );
}

export default StatusIndicator;


